// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.new-container {
    width: 100%;
    margin: 0;
}

.new-container .title {
    margin: 0 auto 10px;
}

.new-container form {
    background-color: var(--color-bg-dark);
    color: var(--color-text-white);
    width: 100%;
    border: 2px solid var(--color-primary);
    padding: var(--spacing-8) !important;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.new-container form > div {
    width: 48%;
}

.new-container form label {
    margin-bottom: 3px;
    font-size: small;
    color: #ffffff !important; /* Color blanco para contraste con fondo oscuro */
}

.new-container .imagenes {
    width: 100% !important;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.new-container .imagenes > div {
    width: 49%;
}

.new-container .imgs {
    max-width: 50%;
    max-height: 200px;
}
.new-container .toBlockchain {
    padding: var(--spacing-2) var(--spacing-8);
    border: 1px solid var(--color-border-medium);
}

.errorInput {
    background-color: var(--color-danger);
    opacity: 0.2;
}

/* Estilos para el sistema de viviendas múltiples */
.vivienda-container {
    background-color: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--color-primary) !important;
    transition: all 0.3s ease;
}

.vivienda-container:hover {
    background-color: rgba(255, 255, 255, 0.08);
    border-color: var(--color-primary-light) !important;
}

.vivienda-container .btn-danger {
    background-color: var(--color-danger);
    border-color: var(--color-danger);
    color: var(--color-text-white);
    padding: var(--spacing-2) var(--spacing-3);
    font-size: var(--font-size-sm);
    border-radius: var(--spacing-1);
    transition: all 0.15s ease-in-out;
}

.vivienda-container .btn-danger:hover {
    background-color: var(--color-danger-hover);
    border-color: var(--color-danger-hover);
    transform: scale(1.05);
}

.vivienda-container .btn-outline-primary {
    color: var(--color-primary);
    border-color: var(--color-primary);
    background-color: transparent;
}

.vivienda-container .btn-outline-primary:hover {
    color: var(--color-text-white);
    background-color: var(--color-primary);
    border-color: var(--color-primary);
}

.vivienda-container .btn-outline-secondary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: transparent;
    border-color: #6c757d;
    color: #6c757d;
}

.vivienda-container .btn-outline-secondary:disabled i {
    color: #6c757d;
}

@media (max-width: 500px) {
    .new-container .title {
        margin: 15px auto 6px;
    }

    .new-container form {
        padding: 8px !important;
    }

    .new-container form > div {
        width: 100%;
    }

    .new-container .imagenes > div {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-proyect.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,WAAW;IACX,sCAAsC;IACtC,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAE,iDAAiD;AAChF;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,0CAA0C;IAC1C,4CAA4C;AAChD;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA,mDAAmD;AACnD;IACI,2CAA2C;IAC3C,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;IAC3C,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;IACjC,8BAA8B;IAC9B,0CAA0C;IAC1C,8BAA8B;IAC9B,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;IACtC,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.new-container {\n    width: 100%;\n    margin: 0;\n}\n\n.new-container .title {\n    margin: 0 auto 10px;\n}\n\n.new-container form {\n    background-color: var(--color-bg-dark);\n    color: var(--color-text-white);\n    width: 100%;\n    border: 2px solid var(--color-primary);\n    padding: var(--spacing-8) !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.new-container form > div {\n    width: 48%;\n}\n\n.new-container form label {\n    margin-bottom: 3px;\n    font-size: small;\n    color: #ffffff !important; /* Color blanco para contraste con fondo oscuro */\n}\n\n.new-container .imagenes {\n    width: 100% !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.new-container .imagenes > div {\n    width: 49%;\n}\n\n.new-container .imgs {\n    max-width: 50%;\n    max-height: 200px;\n}\n.new-container .toBlockchain {\n    padding: var(--spacing-2) var(--spacing-8);\n    border: 1px solid var(--color-border-medium);\n}\n\n.errorInput {\n    background-color: var(--color-danger);\n    opacity: 0.2;\n}\n\n/* Estilos para el sistema de viviendas múltiples */\n.vivienda-container {\n    background-color: rgba(255, 255, 255, 0.05);\n    border: 1px solid var(--color-primary) !important;\n    transition: all 0.3s ease;\n}\n\n.vivienda-container:hover {\n    background-color: rgba(255, 255, 255, 0.08);\n    border-color: var(--color-primary-light) !important;\n}\n\n.vivienda-container .btn-danger {\n    background-color: var(--color-danger);\n    border-color: var(--color-danger);\n    color: var(--color-text-white);\n    padding: var(--spacing-2) var(--spacing-3);\n    font-size: var(--font-size-sm);\n    border-radius: var(--spacing-1);\n    transition: all 0.15s ease-in-out;\n}\n\n.vivienda-container .btn-danger:hover {\n    background-color: var(--color-danger-hover);\n    border-color: var(--color-danger-hover);\n    transform: scale(1.05);\n}\n\n.vivienda-container .btn-outline-primary {\n    color: var(--color-primary);\n    border-color: var(--color-primary);\n    background-color: transparent;\n}\n\n.vivienda-container .btn-outline-primary:hover {\n    color: var(--color-text-white);\n    background-color: var(--color-primary);\n    border-color: var(--color-primary);\n}\n\n.vivienda-container .btn-outline-secondary:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    background-color: transparent;\n    border-color: #6c757d;\n    color: #6c757d;\n}\n\n.vivienda-container .btn-outline-secondary:disabled i {\n    color: #6c757d;\n}\n\n@media (max-width: 500px) {\n    .new-container .title {\n        margin: 15px auto 6px;\n    }\n\n    .new-container form {\n        padding: 8px !important;\n    }\n\n    .new-container form > div {\n        width: 100%;\n    }\n\n    .new-container .imagenes > div {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
